import { UpsertUserTaskItemAppointmentDialogStore } from './upsert-user-task-item-appointment-dialog.store';
import { Component, effect, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { AppFormGroup } from '../../../../../utils/form.utils';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { RRuleInputComponent } from '../../../../kit/input/rrule-input/r-rule-input.component';
import { DateInputComponent } from '../../../../kit/input/date-input/date-input.component';
import { Validators } from '@angular/forms';
import { UserTaskAppointmentObject } from '@libs/types/src/services/object-type/user/user-task-appointment.object';
import { isInvalid } from '../../../../../modules/shared/helpers/validate';
import { successCreated, successUpdated } from '../../../../../modules/content/content.error';
import {
    UserTaskAppointmentUpdateInput,
} from '@libs/types/src/services/input-type/user/user-task-appointment-update.input';
import { createTaskAppointmentFrag, updateTaskAppointmentFrag } from './upsert-user-task-item-appointment-dialog.query';
import {
    UserTaskAppointmentCreateInput,
} from '@libs/types/src/services/input-type/user/user-task-appointment-create.input';

@Component({
    selector: 'app-upsert-user-task-item-appointment-dialog',
    templateUrl: './upsert-user-task-item-appointment-dialog.component.html',
    styleUrl: './upsert-user-task-item-appointment-dialog.component.scss',
    standalone: true,
    providers: [UpsertUserTaskItemAppointmentDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RRuleInputComponent,
        DateInputComponent,
    ],
})
export class UpsertUserTaskItemAppointmentDialogComponent extends BaseDialogComponent {

    public readonly store = inject(UpsertUserTaskItemAppointmentDialogStore);

    public rruleInput = viewChild<RRuleInputComponent>(RRuleInputComponent);

    protected form = new AppFormGroup({
        id: fb.control<number | null>(null),
        userTaskId: fb.control<number | null>(null),
        date: fb.control<Date | null>(null, Validators.required),
        recurrenceRule: fb.control<string | null>(null),
    });

    protected dateChange = this.form.signalCodeChange<string>('date');

    protected appointment!: UserTaskAppointmentObject;

    constructor() {
        super();

        if (this.dialogConfig.data.appointment) {
            this.appointment = this.dialogConfig.data.appointment;
        } else {
            this.appointment = {
                id: 0,
                userTaskId: this.dialogConfig.data.userTaskId,
                date: new Date().toISOString(),
                recurrenceRule: null,
            };
        }

        this.form.patchValue({ ...this.appointment, date: new Date(this.appointment.date) });

        effect(() => {
            const date = this.dateChange();
            this.rruleInput()?.setInputData({ dtstart: new Date(date.value) });
        });
    }

    override async save(_event: Event): Promise<void> {
        if (isInvalid(this.form)) return;

        const _data = {
            userTaskId: this.form.value.userTaskId!,
            date: this.form.value.date!.toISOString(),
            recurrenceRule: this.form.value.recurrenceRule || null,
        };

        if (this.form.value.id) {
            const data = _data as UserTaskAppointmentUpdateInput;
            data.id = this.form.value.id;
            await this.store.api.updateUserTaskAppointment(data, updateTaskAppointmentFrag);
            successUpdated();
        } else {
            const data = _data as UserTaskAppointmentCreateInput;
            await this.store.api.createUserTaskAppointment(data, createTaskAppointmentFrag);
            successCreated();
        }

        this.dialogRef.close();
    }
}
